module.exports = __webpack_public_path__ + "img/84.eff3d83c.jpg";